module.exports = __webpack_public_path__ + "static/media/spotify-clone-app-logo-white.0f00eefc.png";